import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './font-heading.module.scss';

interface FontHeadingProps {
  className?: string;
  heading: string;
  showPremiumIcon?: boolean;
}

export function FontHeading({className = '', showPremiumIcon = false, ...props}: FontHeadingProps) {
  return (
    <div className={`${styles.fontHeading} flex-row-justify-between`}>
      <Text val={props.heading} className={`${className}`} size={TextSize.XSMALL} bold />
      {showPremiumIcon ? <Icon icon="icon-crown" size={IconSize.SIZE_ICON_20} className={styles.icon} /> : null}
    </div>
  );
}
